import styled from '@emotion/styled'

import { breakpoints, spacing } from 'main/ui'

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;

  > :first-child {
    width: 90px;
  }

  > :last-child {
    margin-left: ${spacing.majorScale(2)}px;
  }

  @media (min-width: ${breakpoints.lg}px) {
    width: 33%;
  }
`
